"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireDefault(require("react"));

const Editor = props => _react.default.createElement("svg", (0, _extends2.default)({
  width: "16px",
  height: "16px",
  viewBox: "4 4 17 17",
  fill: "none"
}, props), _react.default.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M19.71 8l.52-.523a2.06 2.06 0 000-2.897c-.769-.773-2.11-.773-2.88 0l-.524.528L19.711 8zM12 5H7.564c-.964 0-1.477.1-2.012.385-.5.268-.9.666-1.167 1.167C4.1 7.087 4 7.6 4 8.564v8.872c0 .964.1 1.477.385 2.012.268.5.666.9 1.167 1.167C6.087 20.9 6.6 21 7.564 21h8.872c.964 0 1.477-.1 2.012-.385.5-.268.9-.666 1.167-1.167.286-.535.385-1.048.385-2.012V13a1 1 0 10-2 0h-.001v4.606l-.008.278-.008.114-.023.186a1.001 1.001 0 01-.109.321.819.819 0 01-.346.346c-.093.05-.186.085-.321.109l-.186.023a3.754 3.754 0 01-.114.008l-.278.008H7.394l-.278-.008a3.758 3.758 0 01-.114-.008l-.186-.023a1.002 1.002 0 01-.321-.109.818.818 0 01-.346-.346c-.078-.145-.12-.289-.138-.594L6 17.606V8.394l.008-.278.008-.114.023-.186c.024-.135.059-.228.109-.321a.818.818 0 01.346-.346c.145-.078.289-.12.594-.138L7.394 7H12V7a1 1 0 100-2zm6.826 3.63L12.296 15a1 1 0 01-.501.264l-2.104.423a.5.5 0 01-.594-.56l.31-2.213a1 1 0 01.291-.577L16.196 6l2.63 2.63z",
  fill: "#ACB3BE",
  className: "fill"
}));

var _default = Editor;
exports.default = _default;